import { Resource } from './resource';

export class FileUpload extends Resource {
fileName: String;
fileSizeInKB: number;
fileType: String;
originalFileName: String;
}